import {LocalStyleSheet} from '../../../utils/types'

export const styles: LocalStyleSheet = {
    addressLine: {
        display: 'block'
    }
}

export default styles
